module.exports = __webpack_public_path__ + "static/glassbox.bc5594be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/glassbox.png
// module id = 1348
// module chunks = 213720915766396